<script>
  export default {
    name: "ApiDatatableMixin",
    data() {
      return {
        'options': {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
        },
        'items': [],
        'totalItems': 0,
        'loading': true,
        'filter': '',
        'task_types': [],
        'show_unclaimed_only': false,
        'show_claimed_only': false,
        'show_processed_only': false,
        'show_unprocessed_only': false,
        'show_archived': false,
      }
    },
    watch: {
      options() {
        this.loadItems();
      },
      filter() {
        this.loadItems();
      },
      task_types() {
        this.loadItems();
      },
      show_unclaimed_only() {
        this.loadItems();
      },
      show_claimed_only() {
        this.loadItems();
      },
      show_processed_only() {
        this.loadItems();
      },
      show_unprocessed_only() {
        this.loadItems();
      },
      show_archived() {
        this.loadItems();
      },
      api_model() {
        this.loadItems();
      }
    },
    methods: {
      onOptionsUpdate(value) {
        this.options = {
          page: 1,
          itemsPerPage: 10,
          sortBy: [],
          ...this.options,
          ...value,
        };
      },
      async loadItems() {
        if(!this.api_model) {
          return;
        }
        this.loading = true;
        // train_config.all(options, filter, model_type, show_archived) — only four args;
        // passing show_unclaimed_only as 4th broke "Show archived" on the models page.
        let response;
        if (this.api_model === 'train_config') {
          response = await this.$api.train_config.all(
            this.options,
            this.filter,
            this.task_types,
            this.show_archived,
          );
        } else if (this.api_model === 'job') {
          response = await this.$api.job.all(
            this.options,
            this.filter,
            this.task_types,
            this.show_unclaimed_only,
            this.show_claimed_only,
            this.show_processed_only,
            this.show_unprocessed_only,
          );
        } else {
          response = await this.$api[this.api_model].all(
            this.options,
            this.filter,
            this.task_types,
            this.show_unclaimed_only,
            this.show_archived,
          );
        }
        if (response && Array.isArray(response.items)) {
          this.items = response.items;
          this.totalItems = response.total != null ? response.total : response.items.length;
        }
        this.loading = false;
      }
    },
  }
</script>

<style scoped>

</style>